import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Typography from 'Components/UI/Typography';
import CalendarAlertIcon from 'Assets/Images/calendar-alert.svg';
import { useClientSchedulerStateContext } from 'Context/NewClientSchedulerContext';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: theme.palette.facet.primaryGray,
    height: '100%',
  },
  header: {
    color: theme.palette.facet.accentBlue2,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: theme.palette.common.white,
    padding: theme.spacing(8, 4, 8, 4),
  },
  desktopContainer: {
    borderRadius: theme.radius.md,
    width: '33%',
  },
  body: {
    margin: theme.spacing(2),
    textAlign: 'center',
  },
  scheduleMeetingButton: {
    marginTop: theme.spacing(1),
  },
  calendarAlertIcon: {
    marginBottom: theme.spacing(2),
  },
});

const UnableToSchedule = ({
  classes,
  className,
}) => {
  const { responseError } = useClientSchedulerStateContext();
  const error = responseError && responseError.length > 0 ? responseError[0] : null;
  const errorMessage = error?.detail || 'We are unable to schedule this meeting at this time. Please try again later or contact support for assistance.';

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classNames(classes.container)}>
        <img className={classes.calendarAlertIcon} src={CalendarAlertIcon} />
        <Typography variant="h2" className={classes.header}>
          Unable to schedule meeting
        </Typography>
        <Typography variant="body" className={classes.body}>
          {errorMessage}
        </Typography>
      </div>
    </div>
  );
};

UnableToSchedule.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

UnableToSchedule.defaultProps = {
  className: '',
};

export default withStyles(styles)(UnableToSchedule);
